module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="body-hook"></div>\n<div class="loader"></div>\n\n<div class="error-message-container">\n<div id="alert-warn" class="alert alert-warning alert-top" role="alert">\n    <button type="button" class="close alert-close" aria-label="Close"><span aria-hidden="true">×</span></button>\n    <h4>Error!</h4>\n    <span class="alert-msg"></span>\n</div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/layout/body.html
// module id = 527
// module chunks = 0